var frFR = {
	"codeBlock.copied": "Copié",
	"codeBlock.copyLabel": "Copier",
	"inlineCodeBlock.copied": "Copié",
	"inlineCodeBlock.copyLabel": "Copier le code intégré"
};

export { frFR as default };
